export const FLIGHT_OFFER_CATEGORY = {
  Domestic: 'NAC',
  International: 'INT',
} as const;

export const FLIGHT_OFFER_MAX_ITEMS = 8;

export const FLIGHT_OFFERS_CONFIG = {
  Desktop: { initial: 4, step: 4 },
  Mobile: { initial: 1, step: 3, subsequentStep: 3 },
} as const;
